import { DMC } from "common/materials/library/DMC";
import type { MaterialSrc } from "common/materials/materialSrc";
import type { Material } from "three";

export enum MeshHardcodedMaterialType {
  DEBUG_RED_MESH,
  DEBUG_WHITE_MESH,
  INVISIBLE_SHADOW_MESH,
  DESELECTED_OVERRIDE,
}

export const DebugMaterialColors = [
  DMC.SystemColors.Green,
  DMC.SystemColors.Dark_Blue,
  DMC.SystemColors.Light_Brown,
  DMC.SystemColors.Purple,
  DMC.SystemColors.Dark_Green,
  DMC.SystemColors.Orange,
  DMC.SystemColors.Yellow,
  DMC.SystemColors.Green,
  DMC.SystemColors.Pink,
  DMC.SystemColors.Blue,
  DMC.SystemColors.White,
  DMC.SystemColors.Gray80,
] as const;

export interface MaterialFactory {
  designMaterialIsFetched(materialId: MaterialSrc): boolean;
  getDesignMaterial(materialId: MaterialSrc | undefined): Promise<Material | undefined>;
  getDesignMaterialWithColor(colorId: number): Promise<Material | undefined>;
  getHardcodedMaterial(hardcodedMaterialType: MeshHardcodedMaterialType): Material;
}
